import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2e521992")

_pushScopeId("data-v-2e521992")
const _hoisted_1 = { class: "ImpersonatePanel" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, "Внимание! Вы авторизованы под сессией пользователя!", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Пожалуйста "),
  /*#__PURE__*/_createVNode("u", null, "будьте бдительны"),
  /*#__PURE__*/_createTextVNode("!")
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Сессия истекла ")
const _hoisted_5 = { class: "ImpersonatePanel__actions" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Выйти с сессии ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_button = _resolveComponent("s-button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", null, [
      _hoisted_2,
      _hoisted_3,
      _createVNode("p", null, [
        (_ctx.impersonate_state.time > 0)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" Сессия истечёт через " + _toDisplayString(_ctx.impersonate_state.time) + " " + _toDisplayString(_ctx.declOfNum(_ctx.impersonate_state.time, _ctx.MINUTES_TOKENS)), 1)
            ], 64))
          : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _hoisted_4
            ], 64))
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_s_button, {
        class: "black",
        onClick: _ctx.impersonateQuit
      }, {
        default: _withId(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
})